module.exports = "\n<cat-menu-left></cat-menu-left>\n<cat-top-bar></cat-top-bar>\n<div class=\"cat__content\">\n    <router-outlet></router-outlet>\n    <!--<cat-footer></cat-footer>-->\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/app.html
// module id = ../../../../../src/app/app.html
// module chunks = main